import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import { vModelText as _vModelText, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createBlock as _createBlock } from "vue";
import _imports_0 from '../../../assets/audioGuide/search.png';
const _hoisted_1 = {
  class: "searchBox"
};
const _hoisted_2 = ["placeholder"];
const _hoisted_3 = {
  key: 0,
  class: "othersBtn"
};
const _hoisted_4 = {
  class: "swiper swiper-container",
  ref: "swiperNav"
};
const _hoisted_5 = {
  class: "swiper-wrapper"
};
const _hoisted_6 = {
  class: "swiper-image swiper-slide"
};
const _hoisted_7 = ["onClick", "src"];
const _hoisted_8 = {
  class: "title-box"
};
const _hoisted_9 = {
  class: "exhibition-title"
};
const _hoisted_10 = {
  key: 1,
  class: "changeLanguage"
};
const _hoisted_11 = {
  class: "exhibition-menu"
};
const _hoisted_12 = {
  key: 2,
  class: "exhibition-box"
};
const _hoisted_13 = {
  key: 3,
  class: "nullBox"
};
const _hoisted_14 = {
  class: "nullTips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_exhibitionItem = _resolveComponent("exhibitionItem");
  const _component_qrCode3 = _resolveComponent("qrCode3");
  const _component_guideBottom = _resolveComponent("guideBottom");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audioGuideItem ${_ctx.$route.query.fid == 152288 ? 'nxbwgDz' : ''}`)
  }, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("input", {
    placeholder: $data.language ? '名称' : 'search',
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.inputValue = $event),
    style: _normalizeStyle(!$data.language ? 'letter-spacing: 0' : '')
  }, null, 12, _hoisted_2), [[_vModelText, $data.inputValue]]), _createElementVNode("div", {
    class: "search-icon",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.search && $options.search(...args))
  }, _cache[9] || (_cache[9] = [_createElementVNode("img", {
    src: _imports_0,
    class: "search-icon"
  }, null, -1)]))]), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
    onClick: _cache[2] || (_cache[2] = $event => $data.showQrcode = true)
  }, _toDisplayString($data.language ? '扫码讲解' : 'Scan Code'), 1), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = (...args) => $options.toArticle && $options.toArticle(...args))
  }, _toDisplayString($data.language ? '地图导览' : 'Map Guide'), 1), _createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = (...args) => $options.toExplanation && $options.toExplanation(...args))
  }, _toDisplayString($data.language ? '展厅讲解' : 'Exhibition Hall'), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.bannersList, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
      onClick: $event => $options.toBannerExhibition(item),
      src: item.bannerImage
    }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString($data.language ? item.bannerName : item.englishName), 1)])]);
  }), 256))]), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "swiper-pagination"
  }, null, -1))], 512), $data.exhibitions.length && $data.exhibitions.find(item => {
    return item.en_name;
  }) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", {
    class: _normalizeClass(`chinese ${$data.language ? 'l_active' : ''}`),
    onClick: _cache[5] || (_cache[5] = $event => $options.changeLanguage(1))
  }, "中", 2), _createElementVNode("div", {
    class: _normalizeClass(`english ${!$data.language ? 'l_active' : ''}`),
    onClick: _cache[6] || (_cache[6] = $event => $options.changeLanguage(0))
  }, "En", 2)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    onClick: _cache[7] || (_cache[7] = (...args) => $options.showTheme && $options.showTheme(...args)),
    class: _normalizeClass($data.isActive == 1 ? 'menu_active' : ''),
    style: _normalizeStyle($data.language ? '' : 'font-size: 0.34rem')
  }, _toDisplayString($data.language ? '常设展览' : 'Permanent exhibition'), 7), _createElementVNode("div", {
    onClick: _cache[8] || (_cache[8] = (...args) => $options.showtemporary && $options.showtemporary(...args)),
    class: _normalizeClass($data.isActive == 2 ? 'menu_active' : ''),
    style: _normalizeStyle($data.language ? '' : 'font-size: 0.34rem')
  }, _toDisplayString($data.language ? '临时展览' : 'Temporary Exhibition'), 7)]), $data.exhibitions.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_exhibitionItem, {
    exhibitions: $data.exhibitions,
    formData: $data.formData,
    language: $data.language,
    special: _ctx.$route.query.fid == 152288 ? 'nxbwg' : '',
    childList: $data.childList
  }, null, 8, ["exhibitions", "formData", "language", "special", "childList"])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString($data.inputValue ? '暂无搜索内容' : '暂无内容'), 1)]))], 512), [[_vShow, !$data.showQrcode]]), $data.showQrcode ? (_openBlock(), _createBlock(_component_qrCode3, {
    key: 0,
    show: $data.showQrcode
  }, null, 8, ["show"])) : _createCommentVNode("", true), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createBlock(_component_guideBottom, {
    key: 1,
    activeIndex: 1,
    language: !$data.language
  }, null, 8, ["language"])) : _createCommentVNode("", true)], 2);
}